import { FlexCol, FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { FormulaItem } from '@common/formula';
import { Text } from './Typography';

interface FormulaRowProps extends FlexProps {
    items: FormulaItem[];
}

// N.B. Keep this in sync with mobile/components/FormulaRow.tsx
const FormulaRow = ({ items, ...props }: FormulaRowProps) => {
    return (
        <FlexRow align="flex-start" gap={1} {...props}>
            {items.map((item, i) => {
                if (item.type === 'op') {
                    return (
                        <Text key={i} fontSize="sm" whiteSpace="nowrap">
                            {item.value}
                        </Text>
                    );
                } else {
                    // type == 'term'
                    return (
                        <FlexCol key={i} align="center">
                            <Text fontSize="sm" fontWeight="bold">
                                {item.value}
                            </Text>
                            <Text
                                fontSize="xs"
                                color="textMuted"
                                whiteSpace="nowrap"
                            >
                                {item.title}
                            </Text>
                        </FlexCol>
                    );
                }
            })}
        </FlexRow>
    );
};

export default FormulaRow;
